var _a;
import { CountryType as ServerCountry } from '@api-gen/api';
import { createDataRecordConverter } from '@core/utils/helpers';
import { Country as ClientCountry } from '@features/guidbooks/types';
export var countryMap = createDataRecordConverter((_a = {},
    _a[ClientCountry.None] = ServerCountry.None,
    _a[ClientCountry.Albania] = ServerCountry.Albania,
    _a[ClientCountry.Andorra] = ServerCountry.Andorra,
    _a[ClientCountry.Austria] = ServerCountry.Austria,
    _a[ClientCountry.Belarus] = ServerCountry.Belarus,
    _a[ClientCountry.Belgium] = ServerCountry.Belgium,
    _a[ClientCountry.BosniaAndHerzegovina] = ServerCountry.BosniaAndHerzegovina,
    _a[ClientCountry.Bulgaria] = ServerCountry.Bulgaria,
    _a[ClientCountry.Croatia] = ServerCountry.Croatia,
    _a[ClientCountry.Cyprus] = ServerCountry.Cyprus,
    _a[ClientCountry.CzechRepublic] = ServerCountry.CzechRepublic,
    _a[ClientCountry.Denmark] = ServerCountry.Denmark,
    _a[ClientCountry.Estonia] = ServerCountry.Estonia,
    _a[ClientCountry.Finland] = ServerCountry.Finland,
    _a[ClientCountry.France] = ServerCountry.France,
    _a[ClientCountry.Germany] = ServerCountry.Germany,
    _a[ClientCountry.Greece] = ServerCountry.Greece,
    _a[ClientCountry.Hungary] = ServerCountry.Hungary,
    _a[ClientCountry.Iceland] = ServerCountry.Iceland,
    _a[ClientCountry.Ireland] = ServerCountry.Ireland,
    _a[ClientCountry.Italy] = ServerCountry.Italy,
    _a[ClientCountry.Latvia] = ServerCountry.Latvia,
    _a[ClientCountry.Lithuania] = ServerCountry.Lithuania,
    _a[ClientCountry.Luxembourg] = ServerCountry.Luxembourg,
    _a[ClientCountry.Malta] = ServerCountry.Malta,
    _a[ClientCountry.Moldova] = ServerCountry.Moldova,
    _a[ClientCountry.Monaco] = ServerCountry.Monaco,
    _a[ClientCountry.Montenegro] = ServerCountry.Montenegro,
    _a[ClientCountry.Netherlands] = ServerCountry.Netherlands,
    _a[ClientCountry.NorthMacedonia] = ServerCountry.NorthMacedonia,
    _a[ClientCountry.Norway] = ServerCountry.Norway,
    _a[ClientCountry.Poland] = ServerCountry.Poland,
    _a[ClientCountry.Portugal] = ServerCountry.Portugal,
    _a[ClientCountry.Romania] = ServerCountry.Romania,
    _a[ClientCountry.Russia] = ServerCountry.Russia,
    _a[ClientCountry.SanMarino] = ServerCountry.SanMarino,
    _a[ClientCountry.Serbia] = ServerCountry.Serbia,
    _a[ClientCountry.Slovakia] = ServerCountry.Slovakia,
    _a[ClientCountry.Slovenia] = ServerCountry.Slovenia,
    _a[ClientCountry.Spain] = ServerCountry.Spain,
    _a[ClientCountry.Sweden] = ServerCountry.Sweden,
    _a[ClientCountry.Switzerland] = ServerCountry.Switzerland,
    _a[ClientCountry.Ukrain] = ServerCountry.Ukrain,
    _a));
export var convertToServerCountryData = function (type) {
    if (Array.isArray(type)) {
        return type.map(function (t) { return countryMap.toServer[t]; });
    }
    return countryMap.toServer[type];
};
export var convertToClientCountryData = function (type) {
    if (Array.isArray(type)) {
        return type.map(function (t) { return countryMap.toClient[t]; });
    }
    return countryMap.toClient[type];
};
